// Next Diamonds — Cart order note AJAX save / remove + auto-grow textarea
// Submits to /cart/update.js. Brief status line renders under the field.
(function () {
  'use strict';

  var MAX_HEIGHT = 150;

  // Auto-grow: textarea starts as a single line, grows to fit content.
  // The stylesheet pins .sum-promo__field height with !important, so the
  // inline value must be !important too or the field never grows.
  function autoGrow(el) {
    if (!el) return;
    // Empty field: let the stylesheet's one-line height apply.
    if (!el.value) { el.style.removeProperty('height'); return; }
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('height', Math.min(el.scrollHeight, MAX_HEIGHT) + 'px', 'important');
  }

  function growAll() {
    document.querySelectorAll('textarea[data-autogrow]').forEach(autoGrow);
  }

  // Delegated so textareas re-rendered by cart refreshes keep working.
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('textarea[data-autogrow]')) autoGrow(e.target);
  });
  // is-open = "the customer is typing here": CSS gives it ~4 lines. A class
  // rather than :focus so it also holds when the window itself is not focused.
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('textarea[data-autogrow]')) {
      e.target.classList.add('is-open');
      autoGrow(e.target);
    }
  });
  document.addEventListener('focusout', function (e) {
    if (e.target && e.target.matches && e.target.matches('textarea[data-autogrow]')) {
      e.target.classList.remove('is-open');
      autoGrow(e.target);
    }
  });
  document.addEventListener('cart:refresh', growAll);
  document.addEventListener('cart:updated', growAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', growAll);
  } else {
    growAll();
  }

  function flashStatus(form, msg, ms) {
    var status = form.querySelector('[data-cart-note-status]');
    if (!status) return;
    status.textContent = msg;
    status.classList.add('is-visible');
    setTimeout(function () {
      status.textContent = '';
      status.classList.remove('is-visible');
    }, ms || 1600);
  }

  function syncRemoveButton(form, hasNote) {
    var removeBtn = form.querySelector('[data-cart-note-remove]');
    if (removeBtn) removeBtn.hidden = !hasNote;
    form.classList.toggle('has-note', !!hasNote);
  }

  async function saveNote(note) {
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: note })
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
  }

  // Save — the note row is a div (a nested form gets dropped on the cart
  // page), so we act on the Save click rather than a submit event.
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cart-note-save]') : null;
    if (!btn) return;
    var form = btn.closest('[data-cart-note-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('[data-cart-note-input]');
    if (!input) return;
    var note = input.value;
    btn.disabled = true;

    try {
      await saveNote(note);
      syncRemoveButton(form, note.trim() !== '');
      // Flash "Saved ✓" on the button for ~1.6s, then restore. Form stays
      // visible (no collapse). User can keep editing if they want.
      if (btn) {
        var original = btn.dataset.ndOrigLabel || btn.textContent;
        btn.dataset.ndOrigLabel = original;
        btn.textContent = 'Saved ✓';
        btn.classList.add('is-saved');
        setTimeout(function () {
          btn.textContent = btn.dataset.ndOrigLabel || 'Save';
          btn.classList.remove('is-saved');
          btn.disabled = false;
        }, 1600);
      }
    } catch (err) {
      flashStatus(form, 'Could not save, please try again', 2600);
      if (btn) btn.disabled = false;
    }
  }, true); // capture phase

  // Remove: one click clears the saved note (no need to erase and re-save).
  document.addEventListener('click', async function (e) {
    var removeBtn = e.target.closest ? e.target.closest('[data-cart-note-remove]') : null;
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var form = removeBtn.closest('[data-cart-note-form]');
    var input = form && form.querySelector('[data-cart-note-input]');
    if (!form || !input) return;
    removeBtn.disabled = true;
    try {
      await saveNote('');
      input.value = '';
      autoGrow(input);
      syncRemoveButton(form, false);
      flashStatus(form, 'Note removed', 1600);
    } catch (err) {
      flashStatus(form, 'Could not remove, please try again', 2600);
    }
    removeBtn.disabled = false;
  }, true);
})();
